import './checkbox.module.scss';

import cn from 'classnames';

interface ICheckboxProps extends React.HTMLProps<HTMLInputElement> {
  label?: string;
  labelCustomClass?: string;
}

const Checkbox = ({label, labelCustomClass, ...props}: ICheckboxProps) => {
  return (
    <div className="mb-4">
      <label className={cn('d-flex align-items-center', labelCustomClass)}>
        <input {...props} className="ms-2" type="checkbox" />
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
